import {Injectable} from '@angular/core';
import {IIdentifier} from 'build/project/openapi-cast/project/project-openapi-cast.model';
import {IAllFieldItems, IAllQuestion, IRowContent} from '../field-item-row/row.model';
import {IMetaContent, SHOWTYPE} from 'src/app/shared/components/field-item/field-item.model';


@Injectable()
export class QuestionItemListService {

   constructor () { }

   public createIQuestionMetaContent (array: IMetaContent[], id: string, content: IRowContent): IMetaContent[] {
      if (array.findIndex(element => element.question_id == id) > -1) {
         array[array.findIndex(element => element.question_id == id)].content = content.content;
         array[array.findIndex(element => element.question_id == id)].noData = content.noData;
         array[array.findIndex(element => element.question_id == id)].send = content.send ;
      } else {
         const elem: IMetaContent = {
            content: content.content,
            id: id,
            noData: content.noData,
            send: content.send,
            question_id: id,
            sort: array.length + 1,
            showType: SHOWTYPE.QUESTIONLIST
         };

         array.push(elem);
      }
      return array;
   }

   public sortArray (questionArray: IAllQuestion[]): IAllQuestion[] {
      return questionArray.sort((a: IAllQuestion, b: IAllQuestion) => (a.sort ?? 0) - (b.sort ?? 0));
   }

   public modifyArray (questionArray: IAllQuestion[], val: IIdentifier): IAllFieldItems[] {
      const array: IAllFieldItems[] = questionArray as IAllFieldItems[];
      return array.map(obj => ({...obj, id: val.code}));
   }


}
